"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TEST_TRADE_DETAL_DATA = {
    "stock": [{
        "count": 4,
        "stockday": [{
            "date": 20160311,
            "tradedetail": [{
                "type": 3,
                "typeexplain": "跌幅偏离值达7%的证券"
            }],
            "fweek": {
                "week1": 4.3017088980553915,
                "week4": 3.7124337065409545
            }
        }, {
            "date": 20170908,
            "tradedetail": [{
                "type": 6,
                "typeexplain": "单只标的证券的当日融资买入数量达到当日该证券总交易量的50％以上"
            }],
            "fweek": {
                "week1": -1.3814274750575595,
                "week4": 0.15349194167306215
            }
        }, {
            "date": 20170927,
            "tradedetail": [{
                "type": 6,
                "typeexplain": "单只标的证券的当日融资买入数量达到当日该证券总交易量的50％以上"
            }],
            "fweek": {
                "week1": 1.9455252918287937,
                "week4": -1.867704280155642
            }
        }, {
            "date": 20171110,
            "tradedetail": [{
                "type": 6,
                "typeexplain": "单只标的证券的当日融资买入数量达到当日该证券总交易量的50％以上"
            }, {
                "type": 3,
                "typeexplain": "跌幅偏离值达7%的证券"
            }],
            "fweek": {
                "week1": -1.9002375296912115,
                "week4": 2.6128266033254155
            }
        }],
        "symbol": "600000.sh",
        "name": "浦发银行"
    }],
    "start": 0,
    "end": 0,
    "count": 1,
    "ticket": 0,

    "message": null,
    "code": 0 /*暴露外部用的方法*/
};exports.TEST_TRADE_DETAL_DATA = TEST_TRADE_DETAL_DATA;


//////////////////
// WEBPACK FOOTER
// ./~/hqchart/src/jscommon/umychart.vue.testdataV2/60000.sh.TradeDetal.js
// module id = 306
// module chunks = 0